import React, { useState } from 'react';
import PopupGeneric from '../../Components/PopupGeneric/pop-up-generic';
import { Link } from 'react-router-dom';
import './passreset.css';
import { IoMdMail } from "react-icons/io";
import { MdKeyboardArrowLeft } from "react-icons/md";
import logo1 from "../../Assets/Img/logo.png";

const PassReset = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [isPopupVisible, setPopupVisible] = useState(false);

    const handleSubmit = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email) {
            setError("Please enter your email address!");
        } else if (!emailRegex.test(email)) {
            setError("Please enter a valid email address!");
        } else {
            setError("");
            // Proceed with password reset logic
            setPopupVisible(true);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSubmit();
        }
    };

    return (
        <div>
            <div className='back1'>
                <Link to='/login' className='backbtn1'><MdKeyboardArrowLeft /></Link>
            </div>

            <div className="header">
                <h1>Reset your Password...</h1>
            </div>

            <div className="forgot-password-container">
                <div className="logo1">
                    <img src={logo1} alt="logo1" />
                </div>

                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="input-group1">
                        <span className="icon1"><IoMdMail /></span>
                        <input
                            className="input"
                            type="text"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={handleKeyDown} // Add key down listener
                        />
                    </div>

                    {error && <p className="error-message1">{error}</p>}

                    <button type="button" className="btn-submit1" onClick={handleSubmit}>Submit</button>
                </form>
            </div>

            <PopupGeneric
                isVisible={isPopupVisible}
                onClose={() => setPopupVisible(false)}
                title="Success"
                content={<p>Password reset link sent to your email!</p>}
                actions={
                    <button
                        onClick={() => setPopupVisible(false)}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '5px',
                            backgroundColor: '#003366',
                            color: '#fff',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        OK
                    </button>
                }
            />
        </div>
    );
};

export default PassReset;
